import { render, staticRenderFns } from "./newLocalInvoiceComponent.vue?vue&type=template&id=76810348&"
import script from "./newLocalInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./newLocalInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports